import React from "react";
import {
  useRetrieveCurrentPlanzone,
  useRetrieveSecondaryCriteriaTemplate,
} from "@planzone/view-models";
import { SecondaryCriteriaIcon } from "@common/secondaryCriteriaIcon";
import { TagIcon } from "@common/assets/tagIcon";
import { Props } from "./types";
import { MembersIcon } from "./membersIcon";
import { CalendarIcon } from "./calendarIcon";
import { StatusIcon } from "./statusIcon";

function ColumnIcon({ projectId, criteriaKey, className }: Props) {
  const { planzone } = useRetrieveCurrentPlanzone();
  const { template: planzoneTemplate } = useRetrieveSecondaryCriteriaTemplate(
    planzone.uuid,
    "projectElement",
  );
  const { template: projectTemplate } = useRetrieveSecondaryCriteriaTemplate(
    projectId || "",
    "projectElement",
  );
  const template = [...planzoneTemplate, ...projectTemplate];
  const iconMap = {
    statuses: <StatusIcon className={className} />,
    tags: <TagIcon className={className} />,
    allocations: <MembersIcon className={className} />,
    allocated: <CalendarIcon className={className} />,
    startDate: <CalendarIcon className={className} />,
    endDate: <CalendarIcon className={className} />,
    completionDate: <CalendarIcon className={className} />,
    text: <SecondaryCriteriaIcon type="text" className={className} />,
    date: <SecondaryCriteriaIcon type="date" className={className} />,
    number: <SecondaryCriteriaIcon type="number" className={className} />,
    list: <SecondaryCriteriaIcon type="list" className={className} />,
    document: <SecondaryCriteriaIcon type="document" className={className} />,
    link: <SecondaryCriteriaIcon type="link" className={className} />,
    resource: <SecondaryCriteriaIcon type="resource" className={className} />,
  };
  const criteria = template.find(({ uuid }) => uuid === criteriaKey);

  return (
    iconMap[(criteria ? criteria.type : criteriaKey) as keyof typeof iconMap] ||
    iconMap.text
  );
}

export { ColumnIcon };
